// extracted by mini-css-extract-plugin
export var readonly = "_cc-1";
export var star = "_cc-0";